











































import Vue from 'vue';
import MusicCardList from '@/components/MusicCardList.vue';
import { search } from '@/services/MusicServices';

export default Vue.extend({
  name: 'Search',
  components: {
    MusicCardList,
  },
  data() {
    return {
      q: '',
      order: 'TRACK_DESC',
      titlePlaceholder: 'Flume, ODESZA, DROELOE, Orelsan, ...',
      results: null,
    };
  },
  methods: {
    async submit() {
      const { q, order } = this;
      const tracks = await search({
        q,
        order,
      })
        .then((res: any) => res.json())
        .then(({ data }) => data)
        .catch(err => console.log(err)); // eslint-disable-line

      this.results = tracks;
    },
  },
});
